// extracted by mini-css-extract-plugin
var _1 = "ra-vertical-menu-absolute";
var _2 = "ra-vertical-menu";
var _3 = "ra-vertical-menu-fixed";
var _4 = "ra-vertical-menu-fixed-visible";
var _5 = "ra-vertical-menu-item";
var _6 = "ra-vertical-menu-item-selected";
export { _1 as "verticalMenuAbsoluteCls", _2 as "verticalMenuCls", _3 as "verticalMenuFixedCls", _4 as "verticalMenuFixedVisibleCls", _5 as "verticalMenuItemCls", _6 as "verticalMenuItemSelectedCls" }
